<template>
  <SlottedCard :title="$t('servicesystem.common_objects.machine.model_info')" :icon="'$machine_model'" :fontsize="'h4'">
    <template v-slot:content>
      <!--
<MachineModelImage :size="70" :relativePath="MachineModel && MachineModel.ModelImage"
      />
      -->
      <v-list v-if="MachineModel" dense class="py-0">
        <edit-li :label="$t('servicesystem.common_objects.machine.model')"
          :value="MachineModel ? MachineModel.DisplayName : $t('servicesystem.common_objects.fallbackterms.none')">
        </edit-li>
        <edit-li :label="$t('servicesystem.common_objects.machine.supplier')"
          :value="MachineModel.Supplier ? MachineModel.Supplier.Name : $t('servicesystem.common_objects.fallbackterms.none')">
        </edit-li>
        <edit-li :label="$t('servicesystem.common_objects.machine_type.machine_type')"
          :value="MachineModel.MachineType ? MachineModel.MachineType.Name : $t('servicesystem.common_objects.fallbackterms.none')">
        </edit-li>
        <AssetTypeSelect v-if="assetTypesEnabled" :value="Machine.AssetType && Machine.AssetType.Id" clearable disabled
          hideIcon class="mx-5">
        </AssetTypeSelect>
      </v-list>
      <v-list-item v-else>
        {{ $t("servicesystem.common_objects.fallbackterms.no_machine_model") }}
      </v-list-item>
      <v-row justify="center" no-gutters class="mb-2">
        <v-btn v-if="Machine" color="tertiary" dark small @click="changeModelTrigger++">
          {{ $t('servicesystem.common_objects.machine.change_model') }}
        </v-btn>
      </v-row>
      <ChangeModelInfoDialog :externaltrigger="changeModelTrigger" :machine="Machine" :saveFunction="changeModel">
      </ChangeModelInfoDialog>
    </template>
  </SlottedCard>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EditLi from "@/components/Inputs/EditableListItem.vue";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";
//import MachineModelImage from "@/views/job/newjob/cards/machines/MachineModelImage.vue";
import ChangeModelInfoDialog from "@/components/Dialogs/ChangeModelInfoDialog.vue";
import AssetTypeSelect from "@/components/Inputs/EntityDropdowns/AssetTypeSelect2.vue";

export default {
  name: "MachineModelCard",
  props: ["Machine", "MachineModel"],
  components: {
    EditLi,
    SlottedCard,
    ChangeModelInfoDialog,
    //MachineModelImage,
    AssetTypeSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      changeModelTrigger: 1,
    };
  },

  methods: {
    async changeModel(obj) {
      await this.changeModelInfoOnMachine(
        obj.Id,
        obj.MachineModel?.Id,
        obj.Supplier?.Id,
        obj.AssetType?.Id
      ).then((response) => {
        response.changed = true;
        this.$emit("Update", response);
      })
    }
  },

  computed: {
    assetTypesEnabled() {
      return this.$store.state.GlobalSettings.Features.AssetTypesEnabled;
    },
  },
};
</script>